import { useSettings } from "./tools";
import { useDebugSettings } from "conference/tools";
import { AlertDialog } from "./widgets";
import { Button, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MeetingPageStage } from "./types";
import { defineMessage, FormattedMessage } from "react-intl";

const LiftOff = () => {
    const settings = useSettings();
    const debugSettings = useDebugSettings();

    return (
        <AlertDialog
            title={defineMessage({ id: "meetingPage.liftOff.title", defaultMessage: "You have left the meeting" })}
        >
            <Typography>
                <FormattedMessage
                    id="meetingPage.liftOff.content"
                    defaultMessage="You can close the browser now or ..."
                />
                {debugSettings.enabled && debugSettings.showRestartActiveMeetingPageButton && (
                    <FontAwesomeIcon
                        icon="sync-alt"
                        style={{ marginLeft: 10, cursor: "pointer" }}
                        onClick={() => (settings.stage = MeetingPageStage.SelectClient)}
                    />
                )}
            </Typography>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "1.2em",
                }}
            >
                <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={() => (settings.stage = MeetingPageStage.Room)}
                >
                    <FormattedMessage id="meetingPage.liftOff.rejoin" defaultMessage="rejoin the meeting" />
                </Button>
            </div>
        </AlertDialog>
    );
};

export default LiftOff;
